import { Alert } from 'antd';

/** The one rule a price change needs upfront: Valid from is the new price's own effective date, not a copy of the line it replaces, and Valid to can't be changed from here. */
export function RateLineImportPriceChangeNote() {
  return (
    <Alert
      className="mb-4"
      type="info"
      showIcon
      message="Changing a price"
      description="Set Valid from to the date the new price takes effect — it must be after the current line's own start date, so re-importing an exported row with its own Valid from unchanged won't apply. Leave Valid to matching the current line's; it can't be changed from here."
    />
  );
}
